export const GOOGLE_ADS = {
  CONVERSION_ID: process.env.REACT_APP_GOOGLE_ADS_CONVERSION_ID,
  SIGNUP_LABEL: 'P1eYCPGtupcbEMbYm-8_'
  // PURCHASE_LABEL: 'lOSDCIO_uIobENK9wZZB'
};
